export default {
  Contains: '*',
  Notcontains: '!*',
  StartsWith: '*.',
  EndsWith: '.*',
  Null: 'NULL',
  NotNull: 'NOT NULL',
  Equals: '=',
  NotEquals: '!=',
  GreaterThan: '>',
  GreaterThanEquals: '>=',
  LessThan: '<',
  LessThanEquals: '<=',
  Between: '[]',
  In: 'IN',
  NotIn: 'NOT IN',
};
